// Crypto Wallets → Transactions → Withdrawals (SM-267, split out of the old
// /wallet-ops/orders tab bar). User withdrawal requests through signing and
// broadcast, with the last on-chain error surfaced per row.
import { createFileRoute } from "@tanstack/react-router";
import {
  OrderListPage,
  WithdrawalsTable,
  useAssetMap,
} from "@/components/wallet-ops/orders";
import { fetchCryptoWithdrawals } from "@/lib/wallet-queries";
import type { CryptoWithdrawalOrder } from "@/lib/wallet-types";

export const Route = createFileRoute("/_app/wallet-ops/withdrawals")({
  component: WithdrawalsPage,
});

function WithdrawalsPage() {
  const assets = useAssetMap();
  return (
    <OrderListPage<CryptoWithdrawalOrder>
      title="Withdrawals"
      description="User withdrawal requests from signing through broadcast. Hover any value for the raw wire form; click to copy."
      cardTitle="Withdrawal orders"
      tab="withdrawals"
      fetcher={fetchCryptoWithdrawals}
      renderTable={(items) => <WithdrawalsTable items={items} assets={assets} />}
    />
  );
}
